import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type Toast = { message: string; type: 'info' | 'success' | 'error' } | null;

interface UiState {
  isLoading: boolean;
  isOffline: boolean;
  error: string | null;
  toast: Toast;
}

type UiStore = UiState & {
  setLoading: (v: boolean) => void;
  setOffline: (v: boolean) => void;
  setError: (msg: string | null) => void;
  showToast: (message: string, type?: 'info' | 'success' | 'error') => void;
  clearToast: () => void;
  reset: () => void;
};

const initialState: UiState = {
  isLoading: false,
  isOffline: false,
  error: null,
  toast: null,
};

export const useUiStore = create<UiStore>()(
  immer((set) => ({
    ...initialState,

    setLoading: (v) =>
      set((state) => {
        state.isLoading = v;
      }),

    setOffline: (v) =>
      set((state) => {
        state.isOffline = v;
      }),

    setError: (msg) =>
      set((state) => {
        state.error = msg;
      }),

    showToast: (message, type = 'info') =>
      set((state) => {
        state.toast = { message, type };
      }),

    clearToast: () =>
      set((state) => {
        state.toast = null;
      }),

    reset: () => set(initialState),
  }))
);
